module.exports = __webpack_public_path__ + "img/ined_logo.43628657.svg";